import gql from 'graphql-tag';
import parseOrderMutation from './parseOrderMutation';

export default data => {
  const dataModify = parseOrderMutation(data, [
    'objectType',
    'serviceType',
    'status',
    'index',
    'flexAttribute',
    'mandatoryFlag',
  ]);
  const modifyFlexAttributeMapping = `modifyFlexAttributeMapping(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyFlexAttributeMapping} {
      id
    }
  }
`;
};
